import { useEffect } from 'react';

/**
 *
 * @param {String} state https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
 */
const useAppleAuthSignin = (state) => {
  useEffect(() => {
    const script = window.document.createElement('script');
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;
    window.document.body.appendChild(script);
  }, []);

  const signin = () => {
    if (!window.AppleID.stravaInit) {
      window.AppleID.auth.init({
        clientId: 'com.strava.app.sign.in',
        scope: 'name email',
        redirectURI: 'https://www.strava.com/o_auth/apple',
        state
      });
      window.AppleID.stravaInit = true;
    }
    window.AppleID.auth.signIn();
  };

  return { signin };
};

export default useAppleAuthSignin;
